import { createSlice } from "@reduxjs/toolkit";

export const searchFilterSlice = createSlice({
    name: 'searchFilter',
    initialState:{
        searchData: "",
        filterData: "",
        itemPerPage: "",
    },

    reducers:{
        setSearchData: (state, {payload}) =>{
            state.searchData = payload;
        },
        setFilterData: (state, {payload}) =>{
            state.filterData = payload;
        },
        setItemPerPage: (state, {payload}) =>{
            state.itemPerPage = payload;
        },
        clearsearchFilter: (state) =>{
            state.searchData = "";
            state.filterData = "";
            state.itemPerPage = 5;
        }
    }
});

export const {setSearchData, setFilterData, setItemPerPage, clearsearchFilter} = searchFilterSlice.actions;
export default searchFilterSlice.reducer